import { FC } from 'react';
import { useSupportModalState, useSupportModalToggleContext } from '../hooks';

const SupportModalHolder: FC = () => {
  const { isLoaded } = useSupportModalState();
  const { SupportModal } = useSupportModalToggleContext();

  if (!isLoaded) {
    return null;
  }

  return <SupportModal />;
};

export { SupportModalHolder };
